<template>
  <div class="body">
    <div class="bg">
      <div class="slider" v-for="(item, index) in list" :key="index" v-show="index == sorceIndex">
        <img :src="item.img" alt="">
        <video autoplay muted loop playsinline>
          <source :src="item.video" type="video/mp4">
          您的浏览器不支持 HTML5 视频标签。
        </video>
      </div>
    </div>
    <div class="ctl">
      <div class="ctlbox" v-for="(item, index) in list" :key="index" @mousemove="checkvd(index)"
        @mouseleave="stopcheck">
        <img :src="item.img" alt="">
      </div>
    </div>
    <div class="logined" v-if="token">
      <div class="top">
        <div class="avatar" @click="toinfo"><img :src="userinfo.avatar" alt=""></div>
        <div class="name" @click="toinfo">{{ userinfo.nickname }}</div>
        <div class="score" @click="toscore"><img src="../assets/images/score.png" alt="">
          {{ userinfo.usable }}积分</div>
        <div class="help">帮助中心</div>
        <div class="enter" @click="enter">进入控制台</div>
      </div>
      <div class="main">
        <div class="title1">
          <img src="../assets/images/title1.png" alt="">
        </div>
        <div class="title2">
          <img src="../assets/images/title2.png" alt="">
        </div>
        <div class="des">组建你的创作小队，实时协作灵感共振，从想法到成片的一站式工作流</div>
        <div class="search">
          <div class="imgbox">
            <img :src="list[sorceIndex].img" alt="">
          </div>
          <div class="line"></div>
          <div class="btn" @click="towrite">随性创作</div>
          <input type="text" v-model="ser[sorceIndex]">
        </div>
        <div class="beian">
          <img src="../assets/images/beian.webp" alt=""><span>icp备46546号版权所有</span><i>@创视蓝莓星空间2025</i>
        </div>
      </div>
      <div class="introduce">
        <div class="item">
          <img src="../assets/images/it1.png" alt="">
          <div class="it2">组建你的创作小队</div>
          <div class="it3">邀请团队成员，创建私密协作空间</div>
        </div>
        <div class="item i2">
          <img src="../assets/images/it2.png" alt="">
          <div class="it2">实时协作，灵感共振</div>
          <div class="it3">即时交流，版本同步，激发创意火花</div>
        </div>
        <div class="item">
          <img src="../assets/images/it3.png" alt="">
          <div class="it2">从想法到成片</div>
          <div class="it3">完整的AI影视制作工作流</div>
        </div>
      </div>
    </div>
    <div class="login" v-else>
      <div class="l">
        <div class="title1"><img src="../assets/images/title1.png" alt=""></div>
        <div class="title2"><img src="../assets/images/title2.png" alt=""></div>
        <div class="introduce">
          <div class="item">
            <img src="../assets/images/it1.png" alt="">
            <div>
              <div class="it2">组建你的创作小队</div>
              <div class="it3">邀请团队成员，创建私密协作空间</div>
            </div>
          </div>
          <div class="item">
            <img src="../assets/images/it2.png" alt="">
            <div>
              <div class="it2">实时协作，灵感共振</div>
              <div class="it3">即时交流，版本同步，激发创意火花</div>
            </div>
          </div>
          <div class="item">
            <img src="../assets/images/it3.png" alt="">
            <div>
              <div class="it2">从想法到成片</div>
              <div class="it3">完整的AI影视制作工作流</div>
            </div>
          </div>
        </div>
      </div>
      <div class="r">
        <div class="rb">
          <div class="lo1">欢迎回来</div>
          <div class="lo2">还没有账号? <span @click="isregist = !isregist">{{ isregist ? '登录' : '免费注册' }}</span></div>
          <div class="lo3" v-if="!isregist">
            <div :class="ispassword ? 'item' : 'item select'" @click="ispassword = false">短信登录</div>
            <div :class="ispassword ? 'item select' : 'item'" @click="ispassword = true">密码登录</div>
          </div>
          <div class="lo4">
            <input type="number" placeholder="请输入手机号" maxlength="11" v-model="form.phone">
            <div class="tbefore">+86 |</div>
          </div>

          <div class="lo4 lo4-2" v-if="isregist || !ispassword">
            <input type="text" placeholder="请输入验证码" v-model="form.code">
            <div class="tafter">| <span @click="sendyzm" :style="gettime !== 0 ? 'color:rgb(110, 109, 109)' : ''">{{
              gettime === 0 ? '获取验证码' : gettime + 's' }}</span></div>
          </div>

          <!-- 密码 -->
          <div class="lo4 lo4-2" v-if="!isregist && ispassword">
            <input :type="form.eye ? 'text' : 'password'" placeholder="请输入密码" v-model="form.password">
            <div class="tafter"><span @click="form.eye = !form.eye"><img v-show="!form.eye"
                  src="../assets/images/eye-close.png" alt=""><img v-show="form.eye" src="../assets/images/eye.png"
                  alt=""></span></div>
          </div>
          <div v-if="isregist">

            <!-- 注册 -->
            <div class="lo4 lo4-2">
              <input :type="form.eye1 ? 'text' : 'password'" placeholder="请输入密码" v-model="form.password1">
              <div class="tafter"><span @click="form.eye1 = !form.eye1"><img v-show="!form.eye1"
                    src="../assets/images/eye-close.png" alt=""><img v-show="form.eye1" src="../assets/images/eye.png"
                    alt=""></span></div>

            </div>
            <div class="lo4 lo4-2">
              <input :type="form.eye2 ? 'text' : 'password'"
                :style="form.password1 == form.password2 ? '' : 'border:1px solid red'" placeholder="再次输入密码"
                v-model="form.password2">
              <div class="tafter"><span @click="form.eye2 = !form.eye2"><img v-show="!form.eye2"
                    src="../assets/images/eye-close.png" alt=""><img v-show="form.eye2" src="../assets/images/eye.png"
                    alt=""></span></div>

            </div>


          </div>
          <div class="lo5" v-if="!isregist" @click="tologin">立即登录</div>
          <div class="lo5" v-else @click="toregist">注册</div>
          <div class="lo6" @click="isagree = !isagree"><i class="i" v-show="!isagree"></i> <i class="i2"
              v-show="isagree"></i>我已阅读并同意《<a href="/#/agreement" target="_blank">用户协议</a>》和《<a href="/#/privacy"
              target="_blank">隐私政策</a>》</div>
          <div class="lo7"><span></span>其他登录方式<span></span></div>
          <div class="lo8">
            <div class="item"><img src="../assets/images/wx.png" alt=""></div>
            <div class="item"><img src="../assets/images/qq.png" alt=""></div>
            <div class="item"><img src="../assets/images/dy.png" alt=""></div>
            <div class="item"><img src="../assets/images/pg.png" alt=""></div>
            <div class="item"><img src="../assets/images/gg.png" alt=""></div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue';
import { notification } from 'ant-design-vue';
import { mapState, mapGetters, mapMutations, mapActions } from "vuex"
import { getUrlParams } from "@/utils/tools"
let timer = null
let timer2 = null
export default {
  name: "",
  data () {
    return {
      sorceIndex: 0,
      ischeck: true,
      list: [
        {
          img: require('../assets/images/index1.webp'),
          video: require('../assets/videos/index1.webm')
        },
        {
          img: require('../assets/images/index2.webp'),
          video: require('../assets/videos/index2.webm')
        },
        {
          img: require('../assets/images/index3.webp'),
          video: require('../assets/videos/index3.webm')
        },
        {
          img: require('../assets/images/index4.webp'),
          video: require('../assets/videos/index4.webm')
        },
        {
          img: require('../assets/images/index5.webp'),
          video: require('../assets/videos/index5.webm')
        },
        {
          img: require('../assets/images/index6.webp'),
          video: require('../assets/videos/index6.webm')
        },
        {
          img: require('../assets/images/index7.webp'),
          video: require('../assets/videos/index7.webm')
        }
      ],
      ser: [
        '墨水滴落在扎染上，逐渐变为流光散开',
        '星际大战中，飞船不幸被流弹击中爆炸，战士惊慌的跑开',
        '成群的蜜蜂在树上飞舞，一只蜜蜂趴在树上建蜂巢',
        '一群工人在一个大型雕塑头像上干活，雕塑突然用手拉开头顶露出脑干，头皮垂下变为盘旋公路',
        '一个头戴塑料袋的人坐在路边的椅子上办公，一个头戴塑料袋的小孩走过来，办公的人突然想脱下头上的塑料袋',
        '一颗可可豆由远及近，在放大到最大时突然爆开，变成可可粉',
        '冰块突然落到一杯柠檬水里溅起水花，镜头一转变为在列车上，镜头对着外面的白云',
      ],
      login: false,
      ispassword: false,
      isregist: false,
      form: {
        eye: false,
        eye1: false,
        eye2: false
      },
      isagree: false,
      gettime: 0,
      userinfo: {}
    }
  },
  computed: {
    ...mapGetters("user", ["token", "userInfo"]),
    ...mapGetters("app", ["config"]),
  },
  // watch: {
  // 	token(newValue, oldValue) {
  // 		newValue && this.getDialogList()
  // 	}
  // },
  async created () {
    if (this.token) {
      let result = await this.getUserInfo(this.token)
      this.userinfo = result.data;
    }
  },
  mounted () {
    this.resetName()
    timer = setInterval(() => {

      if (!this.ischeck) return
      this.sorceIndex++
      if (this.sorceIndex > this.list.length - 1) {
        this.sorceIndex = 0
      }
      this.resetName()
    }, 3000);
  },
  destroyed () {
    clearInterval(timer)
  },
  methods: {
    ...mapMutations("user", ["setToken", "setLoginPopup"]),
    ...mapActions("user", ["getUserInfo"]),
    enter () {
      this.$router.push('/helper')
    },
    towrite(){
      sessionStorage.setItem('cw',this.ser[this.sorceIndex])
      this.$router.push('/ai_write')
    },
    toinfo(){
      this.$router.push('/profile')
      
    },
    toscore(){
      this.$router.push('/recharge?tabsId=1')
    },
    // 1.账号密码登录
    accountLogin (obj) {
      this.$http("login.accountLogin", obj).then(res => {
        if (res.code === 1) {
          this.$message.success("登录成功")
          this.loginModal = false
          this.setToken(res.data.token)
          this.getUserInfo(res.data.token)
        }
      })
    },
    // 2.验证码登录/注册
    codeLoginRegister (obj) {
      this.$http("login.smsLogin", obj).then(async res => {
        if (res.code === 1) {
          this.$message.success("登录成功")
          this.loginModal = false
          localStorage.setItem('token',res.data.token)
          this.setToken(res.data.token)
          let result = await this.getUserInfo(res.data.token)
          this.userinfo = result.data;

        }
      })
    },
    // 3.手机号注册
    telPhoneRegister (obj) {
      this.$http("login.smsRegister", obj).then(res => {
        if (res.code === 1) {
          this.$message.success("注册成功")
          this.loginModal = false
          this.setToken(res.data.token)
          this.getUserInfo(res.data.token)
        }
      })
    },
    // 获取验证码
    getMobileCode () {
      let event = "mobilelogin"
      this.$http("login.sendCode", { mobile: this.form.phone, event }).then(res => {
        if (res.code === 1) {
          this.$message.success("验证码发送成功，请注意查收")
          this.gettime = 60
          timer2 = setInterval(() => {
            if (this.gettime === 0) {
              clearInterval(timer2)
              return
            }
            this.gettime--
          }, 1000)
        } else {
          this.code.status = true
        }
      })
      // }
    },
    toregist () {

      if (!this.form.phone || this.form.phone == '' || this.form.phone.length !== 11) {
        notification.warning({
          message: '请输入正确手机号',
          duration: 2,
        });
        return
      }

      if (!this.form.code || this.form.code == '') {
        notification.warning({
          message: '请输入验证码',
          duration: 2,
        });
        return
      }
      if (!this.form.password1 || this.form.password1 == '') {
        notification.warning({
          message: '请输入密码',
          duration: 2,
        });
        return
      }
      if (!this.form.password2 || this.form.password1 !== this.form.password2) {
        notification.warning({
          message: '两次密码不一致',
          duration: 2,
        });
        return
      }
      if (!this.isagree) {
        notification.warning({
          message: '请阅读并同意《用户协议》和《隐私政策》',
          duration: 2,
        });
        return
      }


      let data = {
        phone: this.form.phone,
        code: this.form.code,
        password: this.form.password1
      }
      alert(JSON.stringify(data))


    },
    tologin () {
      if (!this.form.phone || this.form.phone == '' || this.form.phone.length !== 11) {
        notification.warning({
          message: '请输入正确手机号',
          duration: 2,
        });
        return
      }
      if (!this.isagree) {
        notification.warning({
          message: '请阅读并同意《用户协议》和《隐私政策》',
          duration: 2,
        });
        return
      }
      if (this.ispassword) {
        if (!this.form.password || this.form.password == '') {
          notification.warning({
            message: '请输入密码',
            duration: 2,
          });
          return
        }
        let data = {
          account: this.form.phone,
          password: this.form.password
        }
        this.accountLogin(data)
        return
      } else {
        if (!this.form.code || this.form.code == '') {
          notification.warning({
            message: '请输入验证码',
            duration: 2,
          });
          return
        }
        let data = {
          mobile: this.form.phone,
          code: this.form.code,
          spm: getUrlParams().share || "",
          platform: "Web"
        }
        this.codeLoginRegister(data)

      }


    },
    sendyzm () {
      if (this.gettime !== 0) return
      if (!this.form.phone || this.form.phone == '' || this.form.phone.length !== 11) {
        notification.warning({
          message: '请输入正确手机号',
          duration: 2,
        });
        return
      }
      this.getMobileCode()
    },
    checkvd (index) {
      this.sorceIndex = index
      this.ischeck = false
      this.resetName()
    },
    stopcheck () {
      this.ischeck = true
    },
    resetName () {
      let doms = document.querySelectorAll('.ctlbox')
      doms[this.sorceIndex].className = 'ctlbox select'
      doms.forEach((item, index) => {
        if (index < this.sorceIndex) {
          item.className = `ctlbox ctlbox${this.sorceIndex - index}`
        } else if (index > this.sorceIndex) {
          item.className = `ctlbox ctlbox${index - this.sorceIndex}`
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.logined {
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  .top {
    margin-top: 34px;
    margin-right: 40px;
    display: flex;
    justify-content: right;
    color: rgb(110, 109, 109);
    font-size: 16px;

    >div {
      cursor: pointer;
    }

    .avatar {
      width: 32px;
      height: 32px;
      overflow: hidden;
      border-radius: 50%;
      transform: translateY(-4px);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .name {
      margin-left: 4px;
    }

    .score {
      margin-left: 20px;

      img {
        width: 20px;
        transform: translateY(-2px);
      }

      color: #FFA033;
    }

    .help {
      margin-left: 20px;
    }

    .enter {
      margin-left: 16px;
      width: 120px;
      height: 40px;
      background: #262626;
      border-radius: 4px 4px 4px 4px;
      font-size: 16px;
      color: #FFFFFF;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      transform: translateY(-10px);
    }
  }

  .main {
    .title1 {
      margin-top: 134px;
      width: 100%;
      text-align: center;

      img {
        width: 310px;
      }

    }

    .title2 {
      margin-top: 60px;
      width: 100%;
      text-align: center;

      img {
        width: 868px;
      }

    }

    .des {
      margin-top: 16px;
      width: 100%;
      text-align: center;
      font-weight: 500;
      font-size: 28px;
      color: #FFFFFF;
      text-shadow: 2px 2px 1px rgba(0, 0, 0, 0.5);
    }

    .search {
      margin: 0 auto;
      margin-top: 50px;
      width: 860px;
      height: 60px;
      position: relative;

      input {
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.4);
        box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.3);
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #FFFFFF;
        outline: none;
        padding: 0 88px;
        padding-right: 160px;
        font-size: 16px;
      }

      input:hover {
        background-color: #b9b8b875;
      }

      .imgbox {
        border-radius: 8px;
        position: absolute;
        top: 50%;
        left: 16px;
        transform: translateY(-50%);
        width: 36px;
        height: 36px;
        overflow: hidden;
        cursor: pointer;

        img {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          height: 100%;
        }
      }

      .line {
        position: absolute;
        top: 50%;
        left: 68px;
        transform: translateY(-50%);
        height: 24px;
        width: 2px;
        background-color: #fff;
      }

      .btn {
        position: absolute;
        top: 50%;
        right: 16px;
        transform: translateY(-50%);
        width: 120px;
        height: 44px;
        background: #262626;
        border-radius: 4px 4px 4px 4px;
        font-size: 16px;
        color: #FFFFFF;
        text-align: center;
        line-height: 44px;
        cursor: pointer;
      }
    }

    .beian {
      margin-top: 36px;
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: #fdfdfdb7;

      img {
        width: 22px;
      }

      span {
        margin-left: 12px;
      }

      i {
        font-style: normal;
        margin-left: 30px;
      }
    }
  }

  .introduce {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    border-top: 1px solid #ffffff;

    .item {
      width: 33.3%;
      height: 180px;
      text-align: center;
      color: #ffffff;

      img {
        width: 46px;
        margin-top: 28px;
      }

      .it2 {
        font-size: 24px;
        margin-top: 15px;
      }

      .it3 {
        margin-top: 8px;
        font-size: 18px;
        color: #ffffffda;
      }
    }

    .i2 {
      border-left: 1px solid #ffffff;
      border-right: 1px solid #ffffff;
    }
  }
}

.login {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: space-between;

  .l {
    margin-left: 160px;
    margin-top: 40px;

    .title1 {
      width: 148px;

      img {
        width: 100%;
      }
    }

    .title2 {
      width: 650px;
      margin-top: 200px;

      img {
        width: 100%;
      }
    }

    .introduce {
      margin-top: 60px;

      .item {
        display: flex;
        align-items: center;
        margin-bottom: 40px;

        img {
          width: 48px;
          height: 48px;
          margin-right: 16px;
        }

        .it2 {
          font-size: 24px;
          color: #FFFFFF;
        }

        .it3 {
          margin-top: 8px;
          font-size: 18px;
          color: #ffffffd2;
        }
      }
    }
  }

  .r {
    position: relative;
    z-index: 2;
    width: 750px;
    background: linear-gradient(to right, #ffffff00 0%, #ffffff75 30%, #fff 90%, #fff 100%);
    display: flex;
    justify-content: right;

    .rb {
      margin-top: 156px;
      margin-right: 135px;
      width: 460px;

      .lo1 {
        font-size: 24px;
        color: #262626;
      }

      .lo2 {
        margin-top: 12px;
        font-size: 16px;
        color: #595959;

        span {
          color: #FFA033;
          cursor: pointer;
        }
      }

      .lo3 {
        margin-top: 40px;
        width: 100%;
        display: flex;
        height: 36px;

        .item {
          width: 50%;
          height: 100%;
          line-height: 36px;
          text-align: center;
          font-size: 16px;
          font-size: 16px;
          color: #595959;
          background-color: #ffffff4f;
          cursor: pointer;
        }

        .select {
          color: #FFA033;
          background: #ffffffc5;
          box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.25);
          border-radius: 4px 4px 4px 4px;
        }
      }

      .lo4 {
        margin-top: 34px;
        width: 100%;
        height: 46px;
        position: relative;

        input {
          width: 100%;
          height: 100%;
          outline: none;
          background: #ffffffcc;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #DDDDDD;
          padding-left: 70px;
        }

        input:focus {
          border: 1px solid #FFA033;
        }

        .tbefore {
          font-size: 16px;
          color: #262626;
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      .lo4-2 {
        input {
          padding-left: 20px;
          padding-right: 100px;
        }

        .tafter {
          font-size: 14px;
          color: #262626;
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translateY(-50%);
          color: #424242de;
          width: 82px;
          text-align: center;

          span {
            color: #FFA033;
            cursor: pointer;
            margin-left: 6px;

            img {
              width: 20px;
            }
          }
        }
      }

      .lo5 {
        margin-top: 50px;
        width: 460px;
        height: 46px;
        background: #FFA033;
        box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.25);
        border-radius: 8px 8px 8px 8px;
        text-align: center;
        line-height: 46px;
        font-size: 16px;
        color: #FFFFFF;
        cursor: pointer;
      }

      .lo6 {
        font-size: 14px;
        color: #595959;
        margin-top: 20px;
        display: flex;

        a {
          color: #FFA033;
        }

        i {
          font-style: normal;
          display: block;
          width: 14px;
          height: 14px;
          border-radius: 0px 0px 0px 0px;
          border-radius: 50%;
          border: 1px solid #595959;
          margin-right: 6px;
          margin-top: 2px;
        }

        .i2 {
          border: 1px solid #FFA033;
          position: relative;
        }

        .i2::after {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: block;
          content: '';
          width: 60%;
          height: 60%;
          background-color: #FFA033;
          border-radius: 50%;
        }
      }

      .lo7 {
        margin-top: 60px;
        display: flex;
        justify-content: center;
        font-size: 14px;
        color: #595959;

        span {
          width: 140px;
          height: 0px;
          border-top: 1px solid #8C8C8C;
          margin: 0 6px;
          margin-top: 8px;
        }
      }

      .lo8 {
        margin: 0 auto;
        margin-top: 20px;
        width: 360px;
        display: flex;
        justify-content: space-between;

        .item {
          width: 32px;
          cursor: pointer;

          img {
            width: 100%;
            height: 32px;
          }
        }
      }
    }
  }
}

.ctl {
  position: fixed;
  top: 50%;
  right: 50px;
  width: 40px;

  transform: translateY(-50%);

  .ctlbox {
    margin: 0 auto;
    border-radius: 8px;
    margin-top: 20px;
    width: 28px;
    height: 28px;
    overflow: hidden;
    text-align: center;
    position: relative;
    cursor: pointer;

    img {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      height: 100%;
    }
  }

  .ctlbox1 {
    width: 28px;
    height: 28px;
  }

  .ctlbox2 {
    width: 24px;
    height: 24px;
  }

  .ctlbox3 {
    width: 20px;
    height: 20px;
  }

  .select {
    width: 40px;
    height: 40px;
  }
}

.bg {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;

  .slider {
    position: absolute;
    height: 100%;
    width: 100%;
    height: 100%;

    img {
      position: absolute;
      z-index: 1;
      top: 50%;
      left: 0;
      width: 100%;
      height: auto;
      transform: translateY(-50%);
    }

    video {
      position: absolute;
      z-index: 2;
      top: 50%;
      left: 0;
      width: 100%;
      height: auto;
      transform: translateY(-50%);
    }

    @media (max-width: 1910px) {
      img {
        position: absolute;
        z-index: 1;
        top: 0;
        left: 50%;
        width: auto;
        height: 100%;
        transform: translateX(-50%);
      }

      video {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 50%;
        width: auto;
        height: 100%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>